module.exports = __webpack_public_path__ + "static/media/request.8646c43b.wav";